import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, space, media, radii, fontWeights } = theme
  const textLight = colors['neutral-text-contrast-default']
  const bgLight = colors['neutral-background-contrast']
  const bgLightHover = colors['neutral-background-contrast-medium']
  const textDark = colors['neutral-text-default']
  const bgDark = colors['cyan-background-strong-default']
  const bgDarkHover = colors['cyan-background-strong-hover']

interface WarningProps {
  $darkMode?: boolean
}

export const Warning = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  padding: ${space['spacing-sm']};

  a {
    display: inline-block;
    padding: ${space['spacing-xs']} ${space['spacing-sm']};
    border-radius: ${radii['corner-radius-sm']};
    font-weight: ${fontWeights['font-weight-medium']};
  }
  
  a + button {
    top: ${space['spacing-xxs']};
  }


  @media (${media.desktop}) {
    flex-direction: row;
  }
`


export const Close = styled.button`
  display: inline-block;
  width: ${space['spacing-xl']};
  cursor: pointer;
  position: absolute;
  top: ${space['spacing-sm']};
  right: ${space['spacing-sm']};

  @media (${media.desktop}){
    position: relative;
    top: 0;
    right: unset;
    left: ${space['spacing-sm']};
  }
`

export const WarningWrap = styled.div<WarningProps>`
  width: 100%;
  background-color: ${props => props.$darkMode ? bgDark : bgLight};

  ${Warning} {
    a {
      color: ${props => props.$darkMode ? textDark : textLight};
      border: 1px solid ${props => props.$darkMode ? textDark : textLight};
    }

    a:hover {
      background-color: ${props => props.$darkMode ? bgDarkHover : bgLightHover};
    }
  }

  ${Close} {
    svg > path {
      fill: ${props => props.$darkMode ? textDark : textLight};
    }
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};

  @media (${media.phone}) {
    .ds-icon {
      display: none;
    }
  }
`